<div *ngIf="(progress$ | async) as progress">
  <br />
  <div fxLayout="row" fxLayoutAlign="center center">
    <div style="width: 200px; height: 200px;">
      <mat-progress-spinner [diameter]="200" [strokeWidth]="5" color="primary"
        [mode]="progress.percentDone === 100 || progress.percentDone === 0 ? 'indeterminate' : 'determinate'" [value]="progress.percentDone">
      </mat-progress-spinner>
      <div style="position:relative; top: -138px; text-align: center">
        <div style="font-size: 25px;font-weight: 600">{{ progress.percentDone }}%</div>
        <div style="font-size: 12px; margin-top: 8px;">
          <span *ngIf="progress.percentDone === 0">{{ data.initTitle }}</span>
          <span *ngIf="progress.percentDone > 0 && progress.percentDone < 100">{{ data.progressTitle }}</span>
          <span *ngIf="progress.percentDone === 100">{{ data.completionTitle }}</span>
        </div>
        <div *ngIf="(data.isInferiorBrowser$ | async) === false"  style="font-size: 10px; margin-top: 8px;">
          <span>{{ progress.speed }} {{ progress.unit }}</span>
        </div>
      </div>
    </div>
  </div>
  <br />
</div>
